<section class="dup-card" *ngIf="showCard" role="alert" aria-label="Enrollment duplicates require a decision">
  <div *ngIf="loading" class="dup-summary">
    <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
  </div>

  <div *ngIf="!loading && count > 0" class="dup-summary">
    <mat-icon class="dup-icon" svgIcon="mat:warning" aria-hidden="true"></mat-icon>
    <p class="dup-message">
      <span class="dup-count">{{ formattedCount }}</span>
      {{ decisionPhrase }}
    </p>
    <a class="review-link" routerLink="/members/enrollment-duplicates">Review</a>
  </div>
</section>
